// extracted by mini-css-extract-plugin
export default {"water_container":"BookList_water_container__JHaPi","box_group":"BookList_box_group__i0IpX"};